import React from 'react'
import {
  DetailMetaField,
  StyledHeader,
  StyledValue,
  StyledValueContainer
} from './InvoicingDetails.styled'

interface Props {
  label: React.ReactNode
  fullWidth?: boolean
  valueContainer?: boolean
  emphasize?: 'warning'
  'data-test'?: string
  children: React.ReactNode
}

export const InvoiceDetailField: React.FC<Props> = ({
  label,
  fullWidth,
  valueContainer,
  emphasize,
  'data-test': dataTest,
  children
}) => {
  const value = valueContainer ? (
    <StyledValueContainer data-test={dataTest} $emphasize={emphasize}>
      {children}
    </StyledValueContainer>
  ) : (
    <StyledValue data-test={dataTest} $emphasize={emphasize}>
      {children}
    </StyledValue>
  )

  return (
    <DetailMetaField $fullWidth={fullWidth}>
      <StyledHeader>{label}</StyledHeader>
      {value}
    </DetailMetaField>
  )
}
